let holders = 0;

function paint() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (holders > 0) root.setAttribute('data-scroll-locked', '');
  else root.removeAttribute('data-scroll-locked');
}

export function lockScroll(): () => void {
  holders += 1;
  paint();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders = Math.max(0, holders - 1);
    paint();
  };
}
